export enum ProfileEnum {
  admin = 'Administrador',
  seller = 'Perfil de Vendas',
  organization = 'Organização',
}

export type ProfileEnumKeys = keyof typeof ProfileEnum
